import {
  authenticatedEntryRoute,
  unauthenticatedEntryRoute,
} from './checks';

export const resolveEntryRoute = (
  currentPath: string,
  isUserAuthenticated: boolean,
): string | undefined => {
  return isUserAuthenticated ? authenticatedEntryRoute(currentPath) : unauthenticatedEntryRoute(currentPath);
};
